export const SearchParams: SearchParamsT = {
  ARRIVE: 'arrive',
  DEPART: 'depart',
  FLEX_DAYS: 'flex_days',
  FLEX_WEEKS: 'flex_weeks',
  GUESTS: 'guests',
  ADULTS: 'adults',
  CHILDREN: 'children',
  PETS: 'pets',
  RESORT: 'resort_id',
} as const;

export const SearchFilters: SearchFiltersT = {
  BATHROOMS: 'bathrooms',
  BEDROOMS: 'bedrooms',
  BEDS: 'beds',
  FEATURES: 'features',
  GUESTS: 'guests',
  MAX_GUESTS: 'max_guests',
  MAX_PETS: 'max_pets',
  MAX_AMOUNT: 'max_amount',
  MIN_AMOUNT: 'min_amount',
  PETS: 'pets',
  UNIT_TYPES: 'unit_types',
  UNIT_VIEWS: 'unit_views',
} as const;

export const SearchPaginationKeys: SearchPaginationKeysT = {
  SIZE: 'size',
  OFFSET: 'offset',
} as const;

export const SortParams: SortParamsT = {
  SORT_BY: 'sort_by',
  SORT_DIR: 'sort_dir',
} as const;

export const QuerySearchParamKey = {
  ...SearchParams,
  ...SearchFilters,
  ...SearchPaginationKeys,
};
